<template>
    <div ref="root">
        <app-modulebackground
            :module-id="module.id"
            custom-class="jobswidget__background module__background"
        ></app-modulebackground>
        <div
            class="jobswidget__container module__container"
            v-bind:class="{
                'container__boxed--half': [1, 2].includes(module.layout.type),
                container__fluid: [3, 4].includes(module.layout.type),
                container__boxed: [5, 6].includes(module.layout.type)
            }"
        >
            <div class="jobswidget__inner module__inner">
                <div
                    class="jobswidget__inner--main module__inner--main"
                    v-bind:class="{
                        'calc-padding--left': [3].includes(module.layout.type),
                        'calc-padding--right': [4].includes(module.layout.type)
                    }"
                >
                    <div
                        class="jobswidget__inner-row module__inner-row"
                        v-if="module.data.title || module.data.subtitle"
                    >
                        <div class="jobswidget__inner-col module__inner-col">
                            <div class="jobswidget__header module__header">
                                <h2
                                    class="jobswidget__title module__title font-h2 color-h2"
                                    v-if="module.data.title"
                                    v-html="module.data.title"
                                ></h2>
                                <h3
                                    class="jobswidget__subtitle module__subtitle font-h3 color-h3"
                                    v-if="module.data.subtitle"
                                    v-html="module.data.subtitle"
                                ></h3>
                            </div>
                        </div>
                    </div>
                    <div class="jobswidget__inner-row module__inner-row">
                        <div class="jobswidget__inner-col module__inner-col">
                            <div class="jobswidget__content-block module__content-block">
                                <div
                                    class="jobswidget__content-block--left module__content-block--left"
                                    v-bind:class="{
                                        'col__width--full': [1, 2, 3, 4, 5, 6].includes(
                                            module.layout.type
                                        )
                                    }"
                                    v-if="module.data.text"
                                >
                                    <div class="jobswidget__inner-row module__inner-row">
                                        <div class="jobswidget__inner-col module__inner-col">
                                            <div
                                                class="jobswidget__text module__text font-p color-p module__cms"
                                                v-if="module.data.text"
                                                v-html="module.data.text"
                                            ></div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="jobswidget__content-block--right module__content-block--right"
                                    v-bind:class="{
                                        'col__width--full': [1, 2, 3, 4, 5, 6].includes(
                                            module.layout.type
                                        )
                                    }"
                                    v-if="items && Array.isArray(items) && items.length > 0"
                                >
                                    <div class="jobswidget__inner-row module__inner-row">
                                        <div class="jobswidget__inner-col module__inner-col">
                                            <div>
                                                <ul class="jobswidget__jobs-list module__list">
                                                    <li
                                                        class="jobswidget__job-item module__list-item col__width--full border-color-highlighted font-bold check-visibility"
                                                        v-bind:class="{
                                                            'col__width--one-quarter': [
                                                                5,
                                                                6
                                                            ].includes(module.layout.type)
                                                        }"
                                                        v-for="items__value in items"
                                                        v-bind:key="items__value.id"
                                                        :data-preset-id="items__value.preset_id"
                                                        :data-valid-from="
                                                            items__value.data.valid_from
                                                        "
                                                        :data-valid-until="
                                                            items__value.data.valid_until
                                                        "
                                                    >
                                                        <component
                                                            :is="
                                                                getPageUrlFromType('jobs')
                                                                    ? 'a'
                                                                    : 'span'
                                                            "
                                                            v-on:click.prevent="scrollInsideEditor"
                                                            v-bind:href="
                                                                getPageUrlFromType('jobs')
                                                                    ? getPageUrlFromType('jobs') +
                                                                      '/#' +
                                                                      items__value.id
                                                                    : null
                                                            "
                                                            v-bind:class="{
                                                                'jobswidget__job-item--inner flex--wrap font-bold module__link': [
                                                                    1,
                                                                    2,
                                                                    3,
                                                                    4,
                                                                    5,
                                                                    6
                                                                ].includes(module.layout.type)
                                                            }"
                                                        >
                                                            <app-moduleimage
                                                                v-if="
                                                                    [5, 6].includes(
                                                                        module.layout.type
                                                                    ) && items__value.data.image
                                                                "
                                                                :data="items__value.data.image"
                                                                :width="375"
                                                                :height="250"
                                                                :tag="'img'"
                                                                :custom-class="
                                                                    'jobswidget__job-image jobswidget__moduleimage'
                                                                "
                                                            ></app-moduleimage>
                                                            <span
                                                                class="jobswidget__job-title module__label font-bold color-p"
                                                                >{{ items__value.data.name }}</span
                                                            >
                                                            <span
                                                                class="jobswidget__job-icon"
                                                                v-if="
                                                                    [1, 2, 3, 4].includes(
                                                                        module.layout.type
                                                                    )
                                                                "
                                                                >»</span
                                                            >
                                                        </component>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="jobswidget__inner-row module__inner-row"
                        v-if="getPageUrlFromType('jobs')"
                    >
                        <div class="jobswidget__inner-col module__inner-col">
                            <div class=" jobswidget__cta module__cta">
                                <app-modulebutton
                                    :href="getPageUrlFromType('jobs')"
                                    :custom-class="
                                        'jobswidget__cta-btn module__cta-btn font-button color-button bg-color-button'
                                    "
                                >
                                    Erfahren Sie mehr
                                </app-modulebutton>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    class="jobswidget__inner--image module__inner--image"
                    v-if="
                        [3, 4].includes(module.layout.type) &&
                            module.data.image &&
                            module.data.image.id
                    "
                >
                    <app-moduleimage
                        v-if="[3, 4].includes(module.layout.type)"
                        :data="module.data.image"
                        :tag="'div'"
                        :custom-class="'jobswidget__moduleimage module__moduleimage'"
                    ></app-moduleimage>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ModuleButton from '@/components/assorted/ModuleButton';
import ModuleImage from '@/components/assorted/ModuleImage';
import ModuleBackground from '@/components/assorted/ModuleBackground';

export default {
    data() {
        return {};
    },
    components: {
        'app-modulebutton': ModuleButton,
        'app-moduleimage': ModuleImage,
        'app-modulebackground': ModuleBackground
    },
    methods: {
        ...mapActions(['scrollInsideEditor'])
    },
    computed: {
        ...mapGetters(['getListItems', 'getPageUrlFromType']),
        items() {
            let d_valid_from = new Date();
            d_valid_from.setHours(23);
            d_valid_from.setMinutes(59);
            let d_valid_until = new Date();
            d_valid_until.setHours(0);
            d_valid_until.setMinutes(0);
            return this.getListItems('deha.user.misc.jobs')
                .filter(
                    (i) =>
                        (i.data.valid_from === undefined ||
                            i.data.valid_from === null ||
                            i.data.valid_from === '' ||
                            new Date(i.data.valid_from) <= d_valid_from) &&
                        (i.data.valid_until === undefined ||
                            i.data.valid_until === null ||
                            i.data.valid_until === '' ||
                            new Date(i.data.valid_until) >= d_valid_until)
                )
                .slice(0, 4);
        }
    },
    props: {
        module: Object
    },
    mounted() {}
};
</script>
